import { render } from "./PatientCard.vue?vue&type=template&id=6e68ec94"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=6e68ec94&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__